import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleDots12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSpeechBubbleDots12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.429 10V9H1.5a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H6.613l-.286.26-1.898 1.728zm6.071 0H7l-1.898 1.727a1 1 0 0 1-1.673-.74V10H1.5A1.5 1.5 0 0 1 0 8.5v-6A1.5 1.5 0 0 1 1.5 1h9A1.5 1.5 0 0 1 12 2.5v6a1.5 1.5 0 0 1-1.5 1.5M3.25 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M6 6.5A.75.75 0 1 0 6 5a.75.75 0 0 0 0 1.5m3.5-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleDots12);
